import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import Cookies from "js-cookie";
import OwnerLogin from "./components/Pages/OwnerLogin";
import Login from "./components/Pages/Login";
import AdminLogin from "./components/Pages/AdminLogin";
import ServiceDetails from "./components/Pages/ServiceDetails";
import AdminDashboard from "./components/Pages/AdminDashboard/AdminDashboard.jsx";
import Settings from "./components/Pages/Settings";
import PersonalInformation from "./components/Pages/PersonalInformation";
import Appointment from "./components/Pages/Appointement/Appointment.jsx";
import ForgetPassword from "./components/Pages/ForgetPassword";
import Branch from "./components/Pages/Branch";
import PrivateRoute from "./utils/PrivateRoute";
import OwnerDashboard from "./components/Pages/OwnerDashboard";
import ErrorPage from "./components/Pages/ErrorPage";
import GlobalErrorPage from "./components/Pages/GlobalErrorPage";
import BusinessAnalysis from "./components/Pages/Analysis/BusinessAnalysis.jsx";
import Help from "./components/Pages/Help";
import AppointAsInv from "./components/Pages/AppointAsInv";
import Inventory from "./components/Pages/Inventory";
import CLP_Setting from "./components/Pages/CLP_Setting";
import CustomerL from "./components/Pages/CustomerL";
import StaffManagement from "./components/Pages/StaffManagement";
import AdminManagement from "./components/Pages/AdminManagement";
import StaffSetting from "./components/Pages/StaffSetting";
import "./index.css"; // Assuming you have global styles
import ExpensesManagement from "./components/Pages/ExpenseMnt";
import ExpenseSetting from "./components/Pages/ExpenseSetting";
import Damo from "./components/Pages/Damo";
import CustomerLoyality from "./components/Pages/CustomerLoyality";
import AllAppointment from "./components/Pages/Appointement/AllAppointment";
import Inquiries from "./components/Pages/Inquery/Inquires.jsx";
import NewInquiry from "./components/Pages/Inquery/NewInquiry.jsx";
import CompanyTarget from "./components/Pages/CompanyTarget.jsx";
import InvenotrySetting from "./components/Pages/InvenotrySetting.jsx";
import Templates from "./components/Pages/Templates.jsx";
import MessageDetails from "./components/Pages/MessageDetails.jsx";
import WhatsappTemplates from "./components/Pages/WhatsappTemplates.jsx";
import WhatsappDetail from "./components/Pages/WhatsappDetail.jsx";
import GenerateInvoice from "./components/Pages/Invoice/GenerateInvoice.js";
import ViewInvoice from "./components/Pages/Invoice/ViewInvoice.js";
import Invoice from "./components/Pages/Invoice/Invoice.js";
import ViewAllInvoices from "./components/Pages/Invoice/ViewAllInvoice.jsx";
import VendorSettingsPage from "./components/Pages/VendorSetting.jsx";
import PurchasesManagement from "./components/Pages/PurchasingMnt.jsx";
import StaffLogin from "./components/Pages/staff-app/login/staffLogin";
import StaffDashboard from "./components/Pages/staff-app/dashboard/StaffDashboard.jsx";
import MobileOnly from "./components/Pages/staff-app/MobileOnly.jsx";
import AttendanceDashboard from "./components/Pages/AttendanceDashboard/AttendanceDashboard.jsx";
function App() {
    const isLoggedIn = Cookies.get("loggedIn") === "true";
    const salonName = Cookies.get("salonName");

    return (
        <div>
            <Router>
                <Routes>
                    <Route path="/" element={<OwnerLogin />} />
                    <Route
                        path="/forgetpassword"
                        element={<ForgetPassword />}
                    />

                    <Route element={<PrivateRoute />}>
                        <Route path="/:salon_name" element={<Branch />} />
                        <Route
                            path="/:salon_name/owner"
                            element={<OwnerDashboard />}
                        />
                        <Route
                            path="/:salon_name/:branchName/dashboard"
                            element={<AdminDashboard />}
                        />
                        <Route
                            path="/:salon_name/:branchName/service"
                            element={<ServiceDetails />}
                        />
                        <Route
                            path="/:salon_name/:branchName/settings"
                            element={<Settings />}
                        />
                        <Route
                            path="/:salon_name/:branchName/appointment"
                            element={<Appointment />}
                        />
                        <Route
                            path="/:salon_name/:branchName/settings/personalInformation"
                            element={<PersonalInformation />}
                        />
                        <Route
                            path="/:salon_name/:branchName/generatebill"
                            element={<GenerateInvoice />}
                        />
                        <Route
                            path="/:salon_name/:branchName/view-all-invoices"
                            element={<ViewAllInvoices />}
                        />
                        <Route
                            path="/:salon_name/:branchName/:slno/invoice"
                            element={<Invoice />}
                        />
                        <Route
                            path="/:salon_name/:branchName/viewinvoice/:id"
                            element={<ViewInvoice />}
                        />
                        <Route
                            path="/:salon_name/:branchName/analysis"
                            element={<BusinessAnalysis />}
                        />
                        <Route
                            path="/:salon_name/:branchName/help"
                            element={<Help />}
                        />
                        <Route
                            path="/:salon_name/:branchName/generatebil"
                            element={<AppointAsInv />}
                        />
                        <Route
                            path="/:salon_name/:branchName/inventory"
                            element={<Inventory />}
                        />
                        <Route
                            path="/:salon_name/:branchName/invetorysetting"
                            element={<InvenotrySetting />}
                        />
                        <Route
                            path="/:salon_name/:branchName/vendorsetting"
                            element={<VendorSettingsPage />}
                        />

                        <Route
                            path="/:salon_name/:branchName/settings/clpsetting"
                            element={<CLP_Setting />}
                        />

                        <Route
                            path="/:salon_name/:branchName/attendance"
                            element={<StaffManagement />}
                        />
                        <Route
                            path="/:salon_name/:branchName/staff"
                            element={<AdminManagement />}
                        />
                        <Route
                            path="/:salon_name/:branchName/staffSettings"
                            element={<StaffSetting />}
                        />
                        <Route
                            path="/:salon_name/:branchName/expense"
                            element={<ExpensesManagement />}
                        />
                        <Route
                            path="/:salon_name/:branchName/Purchase"
                            element={<PurchasesManagement />}
                        />
                        <Route
                            path="/:salon_name/:branchName/expenseSetting"
                            element={<ExpenseSetting />}
                        />
                        <Route
                            path="/:salon_name/:branchName/demo"
                            element={<Damo />}
                        />
                        <Route
                            path="/:salon_name/:branchName/customer-loyality"
                            element={<CustomerLoyality />}
                        />
                        <Route
                            path="/:salon_name/:branchName/view-all-Appointments"
                            element={<AllAppointment />}
                        />
                        <Route
                            path="/:salon_name/:branchName/inquiries"
                            element={<Inquiries />}
                        />
                        <Route
                            path="/:salon_name/:branchName/new-inquiry"
                            element={<NewInquiry />}
                        />
                        <Route
                            path="/:salon_name/:branchName/targetsetting"
                            element={<CompanyTarget />}
                        />
                        <Route
                            path="/:salon_name/:branchName/templates"
                            element={<Templates />}
                        />
                        <Route
                            path="/:salon_name/:branchName/message-details"
                            element={<MessageDetails />}
                        />
                        <Route
                            path="/:salon_name/:branchName/whatsapp-templates"
                            element={<WhatsappTemplates />}
                        />
                        <Route
                            path="/:salon_name/:branchName/whatsapp-details"
                            element={<WhatsappDetail />}
                        />
                    </Route>
                    <Route
                        path="/staff/login"
                        element={
                            <MobileOnly>
                                <StaffLogin />
                            </MobileOnly>
                        }
                    />
                    <Route
                        path="/staff/:salon_name/:branchName/staffdashboard"
                        element={
                            <MobileOnly>
                                <StaffDashboard />
                            </MobileOnly>
                        }
                    />
                    <Route
                        path="/:salon_name/:branchName/attendancedashboard"
                        element={<AttendanceDashboard />}
                    />

                    <Route path="*" element={<ErrorPage />} />
                    <Route path="/error" element={<GlobalErrorPage />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
